export enum TagNotificacao {
	INFO = <any>'info',
	IMPORTANT = <any>'importante',
	RESOLVIDO = <any>'resolvido',
	PENDENTE = <any>'pendente',
	ALERT = <any>'alerta'
}
